import { _ as a } from "./index.es406.js";
import { _ as s } from "./index.es407.js";
import { i as e } from "./index.es408.js";
var i = a, y = s, k = e;
function m(r) {
  return k(r) ? i(r) : y(r);
}
var p = m;
export {
  p as k
};
//# sourceMappingURL=index.es270.js.map
